import React from 'react'

const CondicionesSistemaCitas = () => {
  return (
    <main className="site-width pagina-politica">
      <h2>Condiciones del Sistema de Citas</h2>

      <p>
        En Barber Mujica valoramos tu privacidad y tu confianza. Por eso, queremos explicarte de forma clara y
        transparente cómo funciona nuestro sistema de citas, qué datos recogemos, cómo los utilizamos y qué implica
        tu aceptación al reservar a través de nuestra plataforma.
      </p>


      <h3>1. Creación de cuenta automática</h3>
      <p>
        Al marcar el check de aceptación en el formulario de reserva, estás dando tu consentimiento para la
        <strong> creación de una cuenta de usuario en segundo plano</strong> dentro de nuestra plataforma.
        Esta cuenta se genera automáticamente a partir de los datos que introduces: nombre, número de teléfono y, si lo deseas, correo electrónico.
      </p>
      <p>
        El objetivo de esta cuenta es permitirte acceder en el futuro a tu historial de citas, cancelar una reserva o consultar detalles de tus servicios anteriores. 
        Para reprogramar una cita, deberás cancelar la anterior y crear una nueva desde el apartado de reservas.
      </p>


      <h3>2. Datos que recogemos</h3>
      <p>
        Para ofrecerte un servicio funcional y personalizado, nuestro sistema de citas recopila los siguientes datos:
      </p>
      <ul>
        <li><strong>Nombre completo:</strong> Para identificarte correctamente en el sistema.</li>
        <li><strong>Número de teléfono:</strong> Para enviarte confirmaciones, recordatorios o comunicarnos contigo en caso de incidencias.</li>
        <li><strong>Correo electrónico (opcional):</strong> Si decides incluirlo, podremos enviarte notificaciones por email sobre el estado de tus citas (confirmaciones, cancelaciones, recordatorios, etc.).</li>
        <li><strong>Fecha y hora de tu cita:</strong> Para la correcta organización de nuestra agenda y asegurar que tu servicio se preste con puntualidad.</li>
        <li><strong>Tipo de servicio reservado:</strong> Para preparar los tiempos y recursos necesarios para atenderte.</li>
      </ul>
      <p>
        Todos estos datos se almacenan de forma segura, protegidos mediante sistemas de cifrado y múltiples capas de seguridad que garantizan su integridad y confidencialidad.
      </p>


      <h3>3. Acceso a tu cuenta</h3>
      <p>
        Una vez creada tu cuenta, puedes iniciar sesión con el número de teléfono que proporcionaste. Desde tu perfil podrás:
      </p>
      <ul>
        <li>Consultar tus próximas citas</li>
        <li>Revisar tu historial de visitas</li>
        <li>Cancelar una cita directamente desde tu panel</li>
        <li>Actualizar tus datos personales</li>
      </ul>
      <p>
        Para reprogramar una cita, deberás cancelarla y volver a reservar desde el sistema. De esta manera aseguramos una correcta gestión de la agenda.
      </p>


      <h3>4. Finalidad del tratamiento de tus datos</h3>
      <p>
        Los datos que recopilamos tienen como única finalidad mejorar tu experiencia como cliente y optimizar la gestión del sistema de citas.
        En ningún caso compartimos tus datos con terceros ni los utilizamos con fines publicitarios o comerciales.
      </p>
      <p>
        Solo se usarán para:
      </p>
      <ul>
        <li>Gestionar tu cita y enviarte confirmaciones o recordatorios</li>
        <li>Mantenerte informado sobre cualquier cambio o incidencia en tu reserva</li>
        <li>Ofrecerte un historial útil de tus servicios en Barber Mujica</li>
      </ul>


      <h3>5. Conservación de los datos</h3>
      <p>
        Tus datos se conservarán en nuestro sistema mientras mantengas activa tu cuenta. Si durante un período prolongado no usas el sistema,
        podremos desactivar tu cuenta, aunque siempre tendrás la posibilidad de reactivarla usando el mismo número de teléfono.
      </p>


      <h3>6. Tus derechos como usuario</h3>
      <p>
        En cualquier momento puedes ejercer tus derechos de acceso, rectificación, cancelación y oposición (ARCO) sobre los datos que almacenamos.
        Solo tienes que escribirnos por WhatsApp o desde el formulario de contacto en la web.
      </p>
      <p>
        También puedes:
      </p>
      <ul>
        <li>Solicitar que te enviemos una copia de tus datos personales</li>
        <li>Modificar tus datos si han cambiado o son incorrectos</li>
        <li>Eliminar tu cuenta y todos los datos asociados</li>
      </ul>


      <h3>7. Seguridad del sistema</h3>
      <p>
        La seguridad de tus datos es una prioridad. Todos los datos personales y de reserva están protegidos mediante cifrado y otras
        medidas de seguridad tecnológicas que impiden accesos no autorizados. Solo el personal autorizado tiene acceso a la información,
        exclusivamente para fines de gestión interna.
      </p>


      <h3>8. Modificaciones de estas condiciones</h3>
      <p>
        Nos reservamos el derecho de modificar estas condiciones si hay cambios en el funcionamiento del sistema o por motivos legales.
        En ese caso, informaremos a todos los usuarios desde la plataforma o vía mensaje para que estén al tanto de cualquier actualización.
      </p>


      <h3>Aceptación de las condiciones</h3>
      <p>
        Al marcar el check de aceptación durante el proceso de reserva, confirmas que has leído, comprendido y aceptas
        las condiciones descritas en esta página. Si no estás de acuerdo con alguna parte de esta política,
        te invitamos a no completar la reserva y, en su lugar, contactar con nosotros para resolver tus dudas.
      </p>


      <h3>Gracias por confiar en Barber Mujica</h3>
      <p>
        Queremos ofrecerte un servicio profesional, claro y seguro. Si tienes cualquier pregunta sobre el uso de tus datos o el sistema de citas,
        no dudes en escribirnos por WhatsApp. Estamos aquí para ayudarte.
      </p>
    </main>
  )
}

export default CondicionesSistemaCitas
